import { replaceArrayItem } from '@lib/utils';
import { call } from '@packages/functions';
import { AxiosResponse } from 'axios';
import { useEffect, useState } from 'react';

interface Options {
    manualRequest: boolean;
    before: () => void;
    after: (response: AxiosResponse) => void;
}

export const useIndex = (model, params, options?: Partial<Options>) => {
    const [items, setItems] = useState<any[]>([]);
    const [firstLoad, setFirstLoad] = useState(false);
    const [pagination, setPagination] = useState({ total: 0, pages: 0, cursor: { next: 1, current: 1, previous: 1 } });
    const [isLoading, setIsLoading] = useState(false);
    const [isError, setIsError] = useState(false);
    const [reloading, setReloading] = useState(0);
    const [requestParams, setRequestParams] = useState(params);

    async function fetchItems() {
        setIsLoading(true);
        setFirstLoad(true);
        setIsError(false);

        try {
            call(options?.before);

            const result = await model.index(requestParams);
            const { items, pagination } = result.data;

            setItems(items);
            setPagination(pagination);

            call(options?.after, result);
        } catch (error) {
            setIsError(true);
        }

        setIsLoading(false);
    }

    useEffect(() => {
        if (!options || !options.manualRequest) {
            // noinspection JSIgnoredPromiseFromCall
            fetchItems();
        }
        // eslint-disable-next-line
    }, [reloading]);

    const updateItems = (item) => {
        if (item.id) {
            const foundItemIdx = items.findIndex((existingItem) => existingItem.id === item.id);
            if (foundItemIdx !== -1) {
                setItems(replaceArrayItem(items, item, foundItemIdx));
            } else {
                setItems([...items, item]);
            }
        } else {
            setItems([...items, item]);
        }
    };

    const reload = (params) => {
        setRequestParams(params);
        setReloading(reloading + 1);
    };

    const request = () => fetchItems();

    return { items, updateItems, firstLoad, pagination, isLoading, isError, reload, options, request };
};
